export const hibachiAccountCategory = 'hibachi'

// Hibachi network mapping to EVM chain IDs
// Hibachi operates on Arbitrum
export const networkEvmChainIds: Record<string, number | undefined> = {
  ARBITRUM: 42161,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {}

// Solana network identifier for Hibachi (not supported)
export const solanaNetwork: string | undefined = undefined
